import {Component} from 'react';
import { doubleToStringMonthly } from '../../objects/CommonUse/double_functions';
import "./css-files/moneyBuilder.css";

class TransactionHistoryDisplayCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
  
        };
    }
    
    setClassNames(){
        this.tranAmtClass = "text-right";
        if (this.props.tranInfo.tranAmt < 0){
            this.tranAmtClass += " text-danger";
        }
        this.tranTypeClass = "text-left ";
        if (this.props.tranInfo.className){
            this.tranTypeClass += this.props.tranInfo.className;
        }
    }
     
    render() {
        this.setClassNames();
        let tranYear = this.props.tranInfo.tranYear;
        if (this.props.tranInfo.tranYear === "all"){
            tranYear = "All Years"
        }
               
    return <>
        <tr>
            <td className={this.tranTypeClass}>{this.props.tranInfo.tranType}</td>
            <td className="text-left">{tranYear}</td>
            <td className={this.tranAmtClass}>
                    {doubleToStringMonthly(this.props.tranInfo.tranAmt)}
            </td>
        </tr>
       
    </>
    }

}

export default TransactionHistoryDisplayCard;